import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import Moment from 'moment';
import axios from 'axios';
import colors from '../../../../../../../constants/colors';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import CalendarNewEvent from '../../ExpandedTabs/Calendar/CalendarNewEvent';

const CalendarEvents = (props) => {
  const { calendarEvents, handleResolveEvent } = props;
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector((s) => s.module?.[moduleBridgeHex]?.permissions);
  const userBridgePermissions = useSelector((state) => state.module[moduleBridgeHex]?.userBridge?.permissions);

  return (
    <CalendarEventsBlock>
      {calendarEvents[0].map((event) => (
        <li
          key={event.id}
          className="text-danger"
        >
          <AppRemixIcon icon="alert" className="mr-1" />
          <span>{event.date}</span>
          {event.comment && <AppRemixIcon icon="chat-4" className="ml-1 mr-1" filled title={event.comment} color={colors.primaryLight} />}
          {(!permissions?.gcl?.module?.plant?.calendar?.fullCalendar
               || permissions?.gcl?.module?.plant?.calendar?.fullCalendar === false)
               && (userBridgePermissions?.level !== 2 || userBridgePermissions?.writeCalendar === true) && (
               <span
                 className="float-right pointer"
                 onClick={() => handleResolveEvent(event.id)}
               >
                 <AppRemixIcon icon="check" color={colors.success} />
               </span>
          )}
        </li>
      ))}
      {calendarEvents[1].map((event) => (
        <li
          key={event.id}
          className={Moment(event.date, 'DD/MM/YYYY').isBefore(Moment().add(3, 'months')) ? 'event-warning' : ''}
        >
          <AppRemixIcon icon="timer" className="mr-1" />
          <span>{event.date}</span>
          {event.comment && <AppRemixIcon icon="chat-4" className="ml-1 mr-1" filled title={event.comment} color={colors.primaryLight} />}
          <AppRemixIcon icon="chat-t" className="mr-1" />
          {(!permissions?.gcl?.module?.plant?.calendar?.fullCalendar
           || permissions?.gcl?.module?.plant?.calendar?.fullCalendar === false)
           && (userBridgePermissions?.level !== 2 || userBridgePermissions?.writeCalendar === true) && (
           <span
             className="float-right pointer"
             onClick={() => handleResolveEvent(event.id)}
           >
             <AppRemixIcon icon="check" color={colors.success} />
           </span>
          )}
        </li>
      ))}
    </CalendarEventsBlock>
  );
};

export default CalendarEvents;

const CalendarEventsBlock = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 0 6px;
  li{
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    &.event-warning{
      color: ${colors.state2};
    }    
  }
  span{
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 1px;
  }
`;
